import { takeLatest } from "redux-saga/effects";
import {
  changePasswordAction,
  getAllUsersAction,
  getInstructorProfileAction,
  getPopularInstructorAction,
  getProfileAction,
  updateProfileAction,
  updateUserActiveAction,
} from "./slices";
import {
  changePasswordWorker,
  getAllUsersWorker,
  getInstructorProfileWorker,
  getPopularInstructorWorker,
  getProfileWorker,
  updateProfileWorker,
  updateUserActiveWorker,
} from "./workers";

const userWatcher = [
  takeLatest(getProfileAction, getProfileWorker),
  takeLatest(updateProfileAction, updateProfileWorker),
  takeLatest(changePasswordAction, changePasswordWorker),
  takeLatest(getPopularInstructorAction, getPopularInstructorWorker),
  takeLatest(getInstructorProfileAction, getInstructorProfileWorker),
  takeLatest(getAllUsersAction, getAllUsersWorker),
  takeLatest(updateUserActiveAction, updateUserActiveWorker),
];

export default userWatcher;
